import { Space } from 'antd'
import { IconAction } from 'general/components/GroupButton/styles'
import TableAction from 'general/components/GroupButton/TableAction'
import { ERR_ANNOUCE_STATUS } from 'general/constants/AppConstants'
import InvoiceHelper from 'general/helpers/InvoiceHelper'
import { AnnouncementAction } from '.'
import dayjs from 'dayjs'

export const getColumnsAnnouncement = ({ onAction }) => {
  return [
    {
      name: 'Tên tổ chức, cá nhân lập chứng từ',
      center: true,
      width: '350px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row?.companyName}
          </p>
        )
      },
    },
    {
      name: 'Mã số thuế',
      center: true,
      width: '210px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-primary text-hover-decoration font-weight-normal m-0 text-maxline-3 mr-4"
            onClick={async () => {}}
          >
            {row?.companyTaxCode}
          </p>
        )
      },
    },
    {
      name: 'Ngày lập thông báo',
      center: true,
      width: '200px',
      cell: (row) => {
        const date = dayjs(row?.date)
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {date.isValid() ? dayjs(row?.date).format('L') : ''}
          </p>
        )
      },
    },
    {
      name: 'Trạng thái phát hành',
      center: true,
      // width: '300px',
      cell: (row) => {
        const { text, color } = InvoiceHelper.renderIssueStatus(
          row?.issueStatus,
        )
        return <div className={`badge badge-light-${color}`}>{text}</div>
      },
    },
    {
      name: 'Hành động',
      center: true,
      compact: true,
      disabled: true,
      minWidth: '100px',
      cell: (row) => {
        return (
          <Space className="w-100 justify-content-end">
            <TableAction
              titleActionText="Xem"
              icon={<IconAction className="fa-light fa-eye" />}
              onClick={() => onAction(AnnouncementAction.VIEW, row)}
            />

            {row?.issueStatus === ERR_ANNOUCE_STATUS.WAITING_FOR_AUTHORITY && (
              <TableAction
                titleActionText="Kiểm tra trạng thái"
                icon={<IconAction className="fa-light fa-file-alt" />}
                onClick={() => onAction(AnnouncementAction.CHECK_STATUS, row)}
              />
            )}

            {row?.issueStatus === ERR_ANNOUCE_STATUS.NOT_SENT_TO_AUTHORITY && (
              <>
                <TableAction
                  titleActionText="Phát hành thông báo"
                  icon={<IconAction className="fa-light fa-paper-plane" />}
                  onClick={() => onAction(AnnouncementAction.ISSUE, row)}
                />
                <TableAction
                  titleActionText="Xoá thông báo"
                  icon={<IconAction className="fa-light fa-trash" />}
                  onClick={() => onAction(AnnouncementAction.DELETE, row)}
                />
                <TableAction
                  icon={<IconAction className="fa-light fa-pen-to-square" />}
                  titleActionText="Chỉnh sửa thông báo"
                  onClick={() => onAction(AnnouncementAction.EDIT, row)}
                />
              </>
            )}

            {row?.issueStatus !== ERR_ANNOUCE_STATUS.NOT_SENT_TO_AUTHORITY && (
              <TableAction
                titleActionText="Xem lịch sử truyền nhận"
                icon={<IconAction className="fa-light fa-clock-rotate-left" />}
                onClick={() => onAction(AnnouncementAction.VIEW_HISTORY, row)}
              />
            )}
          </Space>
        )
      },
    },
  ]
}

export const getColumnsDocument = ({ onAction }) => {
  return [
    {
      name: 'Số chứng từ',
      center: true,
      width: '350px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row?.numberDocument}
          </p>
        )
      },
    },
    {
      name: 'Họ và tên',
      center: true,
      width: '210px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-primary text-hover-decoration font-weight-normal m-0 text-maxline-3 mr-4"
            onClick={async () => {}}
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '210px', // hoặc giá trị phù hợp
            }}
            title={row?.taxpayersName}
          >
            {row?.taxpayersName}
          </p>
        )
      },
    },
    {
      name: 'Ngày lập',
      center: true,
      width: '200px',
      cell: (row) => {
        const date = dayjs(row?.createDate)
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {date.isValid() ? dayjs(row?.createDate).format('L') : ''}
          </p>
        )
      },
    },
    {
      name: 'CCCD/Hộ chiếu',
      center: true,
      width: '210px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-primary text-hover-decoration font-weight-normal m-0 text-maxline-3 mr-4"
            onClick={async () => {}}
          >
            {row?.employeeTaxCode}
          </p>
        )
      },
    },
    {
      name: 'thời gian',
      center: true,
      // width: '300px',
      cell: (row) => {
        return (
          <div className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4">{`${row?.incomeStartMonth} - ${row?.incomeStartMonth}/${row?.incomeYear}`}</div>
        )
      },
    },
    {
      name: 'Hành động',
      center: true,
      compact: true,
      disabled: true,
      minWidth: '100px',
      cell: (row) => {
        return (
          <Space className="w-100 justify-content-end">
            <TableAction
              titleActionText="Xem"
              icon={<IconAction className="fa-light fa-eye" />}
              onClick={() => onAction(AnnouncementAction.VIEW, row)}
            />

            {/* {row?.issueStatus === ERR_ANNOUCE_STATUS.WAITING_FOR_AUTHORITY && (
              <TableAction
                titleActionText="Kiểm tra trạng thái"
                icon={<IconAction className="fa-light fa-file-alt" />}
                onClick={() => onAction(AnnouncementAction.CHECK_STATUS, row)}
              />
            )} */}

            {row?.issueStatus === ERR_ANNOUCE_STATUS.NOT_SENT_TO_AUTHORITY && (
              <>
                <TableAction
                  titleActionText="Phát hành thông báo"
                  icon={<IconAction className="fa-light fa-paper-plane" />}
                  onClick={() => onAction(AnnouncementAction.ISSUE, row)}
                />
                <TableAction
                  titleActionText="Xoá thông báo"
                  icon={<IconAction className="fa-light fa-trash" />}
                  onClick={() => onAction(AnnouncementAction.DELETE, row)}
                />
                <TableAction
                  icon={<IconAction className="fa-light fa-pen-to-square" />}
                  titleActionText="Chỉnh sửa thông báo"
                  onClick={() => onAction(AnnouncementAction.EDIT, row)}
                />
              </>
            )}

            {/* {row?.issueStatus !== ERR_ANNOUCE_STATUS.NOT_SENT_TO_AUTHORITY && (
              <TableAction
                titleActionText="Xem lịch sử truyền nhận"
                icon={<IconAction className="fa-light fa-clock-rotate-left" />}
                onClick={() => onAction(AnnouncementAction.VIEW_HISTORY, row)}
              />
            )} */}
          </Space>
        )
      },
    },
  ]
}
